import Util from './util';

/**
 * 创建ajax对象,可以通过options参数定制ajax对象
 * url:请求的url地址,必须
 * header:请求的头,键值对构成的json对象,默认值null
 * responseType:指定响应的类型,会影响最终放回的结果,默认值''
 * timeout:请求超时,默认值0
 * requestParameter:请求参数,会被拼接到url后面
 * parameter: 附加参数,会被传递给onSuccess或onFail,默认值null
 * debug:如果为true,输出调试信息,默认值false
 * onSuccess:请求成功回调函数,需要参数接受请求的结果,默认值null
 * onFail:请求失败回调函数,默认值null
 * onAbort:请求终止回调函数,默认值null
 * onError:请求失败回调函数,默认值null
 * onTimeout:请求失败回调函数,默认值null
 * @param {Object} options - 不能为null或undefined
 * @returns {XMLHttpRequest} xhr - 返回XMLHttpRequest对象
 */
function get(options) {
    if (!options) {
        throw new Error('参数options无效!');
    }
    let url = options.url;
    if (!url) {
        throw new Error('缺少url属性!');
    }

    const headers = options.headers || null;
    const responseType = options.responseType || '';
    const timeout = options.timeout || 0;
    const requestParameter = options.requestParameter || null;
    if (requestParameter) {
        let queryString;
        if (Util.isString(requestParameter)) {
            queryString = requestParameter;
        } else if (Util.isObject(requestParameter)) {
            const paramArr = [];
            for (const [key, value] of Object.entries(requestParameter)) {
                if (Util.isArray(value) || Util.isObject(value)) {
                    paramArr.push(`${key}=${encodeURIComponent(JSON.stringify(value))}`);
                } else {
                    paramArr.push(`${key}=${encodeURIComponent(value)}`);
                }
            }
            queryString = paramArr.join('&');
        } else {
            throw new Error(`参数格式错误：${JSON.stringify(requestParameter)}`);
        }

        const joinStr = url.indexOf('?') >= 0 ? '&' : '?';
        url = `${url}${joinStr}${queryString}`;
    }

    const parameter = options.parameter || null;
    const debug = options.debug || false;

    const onSuccess = options.onSuccess || null;
    const onFail = options.onFail || null;
    const onAbort = options.onAbort || null;
    const onError = options.onError || null;
    const onTimeout = options.onTimeout || null;

    const xhr = new XMLHttpRequest();
    if (!xhr) {
        throw new Error('创建XMLHttpRequest对象失败!');
    }

    let startTime = null;
    let endTime = null;

    xhr.onloadstart = event => {
        startTime = new Date().getTime();
        if (debug) {
            console.log(`开始请求:${url}    时间:${startTime}`);
            console.log(`附加参数:${JSON.stringify(parameter)}`);
            console.log(event);
        }
    };
    xhr.onabort = event => {
        endTime = new Date().getTime();
        const diff = endTime - startTime;
        const errmsg = `请求终止:${url}    时间:${startTime}    耗时:${diff}`;

        if (debug) {
            console.log(errmsg);
            console.log(`附加参数:${JSON.stringify(parameter)}`);
            console.log(event);
        }

        if (onAbort) {
            onAbort(errmsg, parameter);
        }
    };
    xhr.onerror = event => {
        endTime = new Date().getTime();
        const diff = endTime - startTime;
        const errmsg = `网络错误:${url}    时间:${startTime}    耗时:${diff}`;

        if (debug) {
            console.log(errmsg);
            console.log(`附加参数:${JSON.stringify(parameter)}`);
            console.log(event);
        }

        if (onError) {
            onError(errmsg, parameter);
        }
    };
    xhr.ontimeout = event => {
        endTime = new Date().getTime();
        const diff = endTime - startTime;
        const errmsg = `请求超时:${url}    时间:${startTime}    耗时:${diff}`;

        if (debug) {
            console.log(errmsg);
            console.log(`附加参数:${JSON.stringify(parameter)}`);
            console.log(event);
        }

        if (onTimeout) {
            onTimeout(errmsg, parameter);
        }
    };
    xhr.onload = event => {
        endTime = new Date().getTime();
        const diff = endTime - startTime;

        // 状态码为2xx或304时都算请求成功
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
            if (debug) {
                console.log(`请求成功:${url}    时间:${startTime}    耗时:${diff}`);
                console.log(`附加参数:${JSON.stringify(parameter)}`);
                console.log(xhr.response);
            }

            if (onSuccess) {
                onSuccess(xhr.response, parameter);
            }
        } else {
            const errmsg = `请求失败:${url}    时间:${startTime}    耗时:${diff}    状态:${xhr.status}`;

            if (debug) {
                console.log(errmsg);
                console.log(`附加参数:${JSON.stringify(parameter)}`);
                console.log(event);
            }

            if (onFail) {
                onFail(errmsg, parameter);
            }
        }
    };
    xhr.open('GET', url);
    if (headers) {
        const keys = Object.keys(headers);
        for (let i = 0; i < keys.length; ++i) {
            const key = keys[i];
            const value = headers[key];
            xhr.setRequestHeader(key, value);
        }
    }
    xhr.responseType = responseType;
    xhr.timeout = timeout;
    xhr.send();
    return xhr;
}

/**
 * 创建ajax对象,可以通过options参数定制ajax对象
 * url:请求的url地址,必须
 * header:请求的头,键值对构成的json对象,默认值null
 * responseType:指定响应的类型,会影响最终放回的结果,默认值''
 * timeout:请求超时,默认值0
 * requestParameter:请求参数
 * parameter: 附加参数,会被传递给onSuccess或onFail,默认值null
 * debug:如果为true,输出调试信息,默认值false
 * onSuccess:请求成功回调函数,需要参数接受请求的结果,默认值null
 * onFail:请求失败回调函数,默认值null
 * onAbort:请求终止回调函数,默认值null
 * onError:请求失败回调函数,默认值null
 * onTimeout:请求失败回调函数,默认值null
 * @param {Object} options - 不能为null或undefined
 * @returns {XMLHttpRequest} xhr - 返回XMLHttpRequest对象
 */
function post(options) {
    if (!options) {
        throw new Error('参数options无效!');
    }
    const url = options.url;
    if (!url) {
        throw new Error('缺少url属性!');
    }

    const headers = options.headers || null;
    const responseType = options.responseType || '';
    const timeout = options.timeout || 0;
    const requestParameter = options.requestParameter || null;
    const parameter = options.parameter || null;
    const debug = options.debug || false;

    const onSuccess = options.onSuccess || null;
    const onFail = options.onFail || null;
    const onAbort = options.onAbort || null;
    const onError = options.onError || null;
    const onTimeout = options.onTimeout || null;

    const xhr = new XMLHttpRequest();
    if (!xhr) {
        throw new Error('创建XMLHttpRequest对象失败!');
    }

    let startTime = null;
    let endTime = null;

    xhr.onloadstart = event => {
        startTime = new Date().getTime();

        if (debug) {
            console.log(`开始请求:${url}    时间:${startTime}`);
            console.log(`附加参数:${JSON.stringify(parameter)}`);
            console.log(event);
        }
    };
    xhr.onabort = event => {
        endTime = new Date().getTime();
        const diff = endTime - startTime;
        const errmsg = `请求终止:${url}    时间:${startTime}    耗时:${diff}`;

        if (debug) {
            console.log(errmsg);
            console.log(`附加参数:${JSON.stringify(parameter)}`);
            console.log(event);
        }

        if (onAbort) {
            onAbort(errmsg, parameter);
        }
    };
    xhr.onerror = event => {
        endTime = new Date().getTime();
        const diff = endTime - startTime;
        const errmsg = `网络错误:${url}    时间:${startTime}    耗时:${diff}`;

        if (debug) {
            console.log(errmsg);
            console.log(`附加参数:${JSON.stringify(parameter)}`);
            console.log(event);
        }

        if (onError) {
            onError(errmsg, parameter);
        }
    };
    xhr.ontimeout = event => {
        endTime = new Date().getTime();
        const diff = endTime - startTime;
        const errmsg = `请求超时:${url}    时间:${startTime}    耗时:${diff}`;

        if (debug) {
            console.log(errmsg);
            console.log(`附加参数:${JSON.stringify(parameter)}`);
            console.log(event);
        }

        if (onTimeout) {
            onTimeout(errmsg, parameter);
        }
    };
    xhr.onload = event => {
        endTime = new Date().getTime();
        const diff = endTime - startTime;

        // 状态码为2xx或304时都算请求成功
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
            if (debug) {
                console.log(`请求成功:${url}    时间:${startTime}    耗时:${diff}`);
                console.log(`附加参数:${JSON.stringify(parameter)}`);
                console.log(xhr.response);
            }

            if (onSuccess) {
                onSuccess(xhr.response, parameter);
            }
        } else {
            const errmsg = `请求失败:${url}    时间:${startTime}    耗时:${diff}    状态:${xhr.status}`;

            if (debug) {
                console.log(errmsg);
                console.log(`附加参数:${JSON.stringify(parameter)}`);
                console.log(xhr);
            }

            if (onFail) {
                onFail(errmsg, parameter);
            }
        }
    };
    xhr.open('POST', url);
    if (headers) {
        const keys = Object.keys(headers);
        for (let i = 0; i < keys.length; ++i) {
            const key = keys[i];
            const value = headers[key];
            xhr.setRequestHeader(key, value);
        }
    }
    xhr.responseType = responseType;
    xhr.timeout = timeout;
    xhr.send(requestParameter);
    return xhr;
}

/**
 * 创建单个数据源请求的Promise实例.
 * @param {String} url - 数据源请求url
 * @param {Object} requestParameter - 请求参数
 * @param {Array} additionParameter - 附加参数,会被传递给onSuccess或onFail
 * @param {object} options          - 控制参数，用于设置timeout、debug等
 * @returns {promise} promise - 返回单个数据源数据异步请求实例
 */
function ajaxPromise(url, method, requestParameter, additionParameter, options) {
    let xhr;
    const promise = new Promise((resolve, reject) => {
        const xhrOptions = {
            url: url,
            requestParameter: requestParameter,
            parameter: additionParameter,
            responseType: 'json',
            onSuccess(resp, parameter) {
                resolve(resp);
            },
            onFail(errmsg, parameter) {
                reject({
                    errcode: -1000,
                    errmsg: errmsg,
                    parameter: parameter
                });
            },
            onError(errmsg, parameter) {
                reject({
                    errcode: -1010,
                    errmsg: errmsg,
                    parameter: parameter
                });
            },
            onTimeout(errmsg, parameter) {
                reject({
                    errcode: -1020,
                    errmsg: errmsg,
                    parameter: parameter
                });
            },
            onAbort(errmsg, parameter) {
                reject({
                    errcode: -1030,
                    errmsg: errmsg,
                    parameter: parameter
                });
            },
            ...options
        };

        xhr = method(xhrOptions);
    });

    const abort = () => {
        // 如果request还没有结束的话就执行abort
        if (xhr.readyState !== XMLHttpRequest.UNSENT) {
            xhr.abort();
        }
    };

    return {
        promise,
        abort
    };
}

/**
 * 封装了promise和abort函数的get请求
 * @param {String}} url      请求地址
 * @param {Object} parameter 请求参数
 * @param {Object} options   请求的控制选项
 */
function $get(url, parameter, options) {
    return ajaxPromise(url, get, parameter, null, options);
}

/**
 * 封装了promise和abort函数的post请求
 * @param {String}} url      请求地址
 * @param {Object} parameter 请求参数
 * @param {Object} options   请求的控制选项
 */
function $post(url, parameter, options) {
    return ajaxPromise(url, post, parameter, null, options);
}

export default {
    get,
    post,
    ajaxPromise,
    $get,
    $post
};
